import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getDepartment,
  createDepartment,
  editDepartment,
  resetDepartments,
} from "../../store/departments/actions";

const NewDepartment = ({ t }) => {
  let { idDepartment } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    successDepartment,
    errorDepartment,
    loadingDepartment,
    dataDepartment,
  } = useSelector((state) => state.Department);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [newDepartmentValues, setNewDepartmentValues] = useState({});

  //TODO: Definir se vai ser default ou criar campos
  const activeDefault = true;
  const mainDefault = false;

  const handleCreateDepartment = () => {
    if (!idDepartment) {
      dispatch(
        createDepartment({
          ...newDepartmentValues,
          main: mainDefault,
          active: activeDefault,
        })
      );
    }
  };

  const handleEditDepartment = () => {
    if (idDepartment && newDepartmentValues) {
      dispatch(editDepartment(newDepartmentValues, idDepartment));
    }
  };

  useEffect(() => {
    if (idDepartment) {
      dispatch(getDepartment(idDepartment));
    } else {
      dispatch(resetDepartments());
    }
  }, [dispatch, idDepartment]);

  useEffect(() => {
    if (dataDepartment && dataDepartment.data) {
      setName(dataDepartment.data.name);
      setEmail(dataDepartment.data.email);
    }
  }, [dispatch, dataDepartment]);

  let showToast = useCallback(function (type, msg) {
    toastr[type](msg);
  }, []);

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successDepartment && history.push("/departments"),
  };

  useEffect(() => {
    if (successDepartment && dataDepartment) {
      showToast(
        "success",
        (dataDepartment && dataDepartment.message && dataDepartment.message) ===
          "Department created"
          ? t("Department created")
          : (dataDepartment && dataDepartment.newDepartmentValues.message) ===
              "Department updated" && t("Department updated")
      );
    }
  }, [successDepartment, dataDepartment, t, showToast]);

  useEffect(() => {
    if (errorDepartment) {
      showToast(
        "error",
        errorDepartment[0].value === "email must be a valid email"
          ? t("email must be a valid email")
          : errorDepartment === "Your session has expired"
          ? t("Your session has expired")
          : errorDepartment ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorDepartment ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
      dispatch(resetDepartments());
    }
  }, [dispatch, errorDepartment, showToast, t]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/departments"
            path={"/department"}
            title={t("Departments")}
            breadcrumbItem={
              idDepartment ? t("Edit Department") : t("Create department")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {loadingDepartment && !dataDepartment ? (
                    <div className="text-center">
                      <Spinner size="sm" animation="border" />
                    </div>
                  ) : (
                    <AvForm
                      onValidSubmit={
                        idDepartment
                          ? handleEditDepartment
                          : handleCreateDepartment
                      }
                    >
                      <Row>
                        <Col sm="12">
                          <FormGroup>
                            <AvField
                              label={t("Name") + " *"}
                              id="name"
                              name="name"
                              type="text"
                              className="form-control"
                              placeholder={t("Enter department name")}
                              onChange={(e) => {
                                setName(e.target.value);
                                setNewDepartmentValues({
                                  ...newDepartmentValues,
                                  name: e.target.value,
                                });
                              }}
                              value={name}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                maxLength: {
                                  value: 255,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[0-9A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                  errorMessage: t(
                                    "Your name must be composed only with letter and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              label={t("Email") + " *"}
                              id="registration-email"
                              name="registrationemail"
                              type="email"
                              className="form-control"
                              placeholder={t("example@example.com")}
                              onChange={(e) => {
                                setEmail(e.target.value);
                                setNewDepartmentValues({
                                  ...newDepartmentValues,
                                  email: e.target.value,
                                });
                              }}
                              value={email}
                              validate={{
                                email: {
                                  value: true,
                                  errorMessage: t("Incorrect email"),
                                },
                                maxLength: {
                                  value: 100,
                                  errorMessage: t("Invalid field"),
                                },
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {loadingDepartment ? (
                        <Button
                          disabled={true}
                          style={{
                            cursor: "no-drop",
                          }}
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                        >
                          <Spinner size="sm" animation="border" />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          className="mr-1 waves-effect waves-light"
                          type="submit"
                          id="showtoast"
                        >
                          {t("Confirm")}
                        </Button>
                      )}
                      <Link to="/departments">
                        {" "}
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect btn-dark"
                        >
                          {t("Cancel")}
                        </Button>
                      </Link>
                    </AvForm>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewDepartment);
